module.exports = __webpack_public_path__ + "static/img/st-1.8745fea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/harmony-home/st-1.jpg
// module id = jxOn
// module chunks = 1 2